export var ALWAYS='always';export var NEVER='never';